module.exports = __webpack_public_path__ + "static/media/class-recordings.18add17f.svg";